import React, { Component } from 'react';

import './Pessoas.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import Parallax from 'parallax-js';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import renderHTML from 'react-render-html';
import Swipeable from 'react-swipeable';
import OwlCarousel from 'react-owl-carousel2';
import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	views
} from '../../settings';

import {
	Person,
	HoveredImage,
	Compromisso
} from '../../components/';

class Pessoas extends Component {

	constructor() {
		super();

        this.images = images;

        this.state = {
            width: window.innerWidth
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('5.1 Pessoas');
    }

    componentWillUnmount() {
	}

    componentDidMount() {
    }

	render() {
        const { width } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view', 
			'pessoas'
		];

		var level1_card1 = {
			left: "50%",
			top: "-112px"
		}


		var level2_card1 = {
			left: "15%",
			top: "10%"
		};

		var level2_card2 = {
			left: "39%",
			top: "6.5%"
		};

		var level2_card3 = {
			left: "61%",
			top: "6.5%"
		};

		var level2_card4 = {
			left: "84%",
			top: "10%"
		};

		var level2_card5 = {
			left: "39%",
			top: "22.5%"
		};


		var level3_card1 = {
			left: "14.3%",
			top: "36.5%"
		};

		var level3_card2 = {
			left: "38%",
			top: "36.5%"
		};

		var level3_card3 = {
			left: "61%",
			top: "36.5%"
		};

		var level3_card4 = {
			left: "84%",
			top: "36.5%"
		};


		var level4_card1 = {
			left: "14.3%",
			top: "48.5%"
		};

		var level4_card2 = {
			left: "38%",
			top: "48.5%"
		};

		var level4_card3 = {
			left: "61%",
			top: "48.5%"
		};

		var level4_card4 = {
			left: "84%",
			top: "48.5%"
		};


		var level5_card1 = {
			left: "14.3%",
			top: "60.6%"
		};

		var level5_card2 = {
			left: "38%",
			top: "60.6%"
		};

		var level5_card3 = {
			left: "61%",
			top: "60.6%"
		};

		var level5_card4 = {
			left: "84%",
			top: "60.6%"
		};


		var level6_card1 = {
			left: "14.3%",
			top: "72.5%"
		};

		var level6_card2 = {
			left: "38%",
			top: "72.5%"
		};

		var level6_card3 = {
			left: "61%",
			top: "72.5%"
		};

		var level6_card4 = {
			left: "84%",
			top: "72.5%"
		};


		var level7_card1 = {
			left: "14.3%",
			top: "83.8%"
		};

		var level7_card2 = {
			left: "38%",
			top: "83.8%"
		};

		var level7_card4 = {
			left: "84%",
			top: "83.8%"
		};


		var level8_card1 = {
			left: "14.3%",
			top: "95.8%"
		};

		var level8_card2 = {
			left: "38%",
			top: "95.8%"
		};

        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>5.1 Pessoas - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>5.1</span> Pessoas</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Pessoas</p>
		        			</div>
		        		</header>

		        		<div className="views__content first_view row">
			        		<div className="container">
			        			
				        		<div className="column column--half column--padding-right">
				        			<Fade bottom>
					        			<p className="first_paragraph">
					        				Terminamos 2018 com <b class="green_text">333 funcionários</b>, sendo 205 pessoas no escritório de São Paulo, 110 alocados no Selic e 18 na nossa sede do Rio de Janeiro. Deste total, sete são PCDs (Pessoas com Deficiência).
					        				<br /><br />
											O grande desafio no ano foi a transferência das áreas de negócios (Preços e Índices, Estudos Regulatórios e Tecnologia) da sede do Rio de Janeiro para o escritório de São Paulo. Com isso, foram realizadas 12 transferências de profissionais e suas famílias.
											<br />
										</p>
										<p className="gri_p">
					        				<span className="gri_label"><text>GRI 102-7, 405-1</text></span>
										</p>
				        			</Fade>
				        		</div>
			        			
				        		<div className="column column--half column--padding column--no-padding-mobile text-center">
					        		<HoveredImage
				        				image1={ this.images.pessoas_img_1 }
				        				image2={ this.images.pessoas_img_1_hover } />
				        		</div>

			        		</div> 
		        		</div>

		        		<div className="views__content titled_view disclaimer_view organograma_view--title row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
				        				<h2 className="section_title">Organograma</h2>
				        				<h3 className="titled_view__title titled_view__title--no-line">A estrutura da nossa equipe interna reflete os compromissos assumidos com o mercado:<br />representar, autorregular, informar e educar.</h3>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content titled_view disclaimer_view organograma_view--mobile row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
				        				<img src={ this.images.pessoas_organograma_mobile } />
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content titled_view disclaimer_view organograma_view row">
		        			<div className="organograma">

		        				<div className="organograma__cards">

			        				<div className="card card--level1" style={ level1_card1 }>
			        					<div className="title">Superintendência Geral</div>
			        					<div className="name">José Carlos Doherty</div>
			        				</div>

			        				<div className="card card--level2" style={ level2_card1 }>
			        					<div className="title">Assessoria Jurídica</div>
			        					<div className="name">Soraya Alves</div>
			        				</div>

			        				<div className="card card--level2" style={ level2_card2 }>
			        					<div className="title">Recursos Humanos</div>
			        					<div className="name">Eliana Marino</div>
			        				</div>

			        				<div className="card card--level2" style={ level2_card3 }>
			        					<div className="title">Comunicação e Marketing</div>
			        					<div className="name">Marcelo Billi</div>
			        				</div>

			        				<div className="card card--level2" style={ level2_card4 }>
			        					<div className="title">Controladoria<br />e Administração</div>
			        					<div className="name">Thiago Baptista</div>
			        				</div>

			        				<div className="card card--level2" style={ level2_card5 }>
			        					<div className="title">Tecnologia da Informação </div>
			        					<div className="name">Lina Yajima</div>
			        				</div>



			        				<div className="card card--level3" style={ level3_card1 }>
			        					<div className="title">Representação<br />Institucional</div>
			        					<div className="name">Patrícia Herculano</div>
			        				</div>

			        				<div className="card card--level3" style={ level3_card2 }>
			        					<div className="title">Educação e<br />Informações Técnicas</div>
			        					<div className="name">Ana Leoni</div>
			        				</div>

			        				<div className="card card--level3" style={ level3_card3 }>
			        					<div className="title">Supervisão de Mercados</div>
			        					<div className="name">Guilherme Benaderet</div>
			        				</div>

			        				<div className="card card--level3" style={ level3_card4 }> 
			        					<div className="title">Selic</div>
			        					<div className="name">Francisco Vidinha</div>
			        				</div>


			        				<div className="card card--level4" style={ level4_card1 }>
			        					<div className="title">Fundos de Investimento<br />e Serviços Qualificados </div>
			        					<div className="name">Tatiana Itikawa</div>
			        				</div>

			        				<div className="card card--level4" style={ level4_card2 }>
			        					<div className="title">Certificação e<br />Educação Continuada </div>
			        					<div className="name">Daniel Pfannemuller</div>
			        				</div>

			        				<div className="card card--level4" style={ level4_card3 }>
			        					<div className="title">Ofertas Públicas<br />e Certificação</div>
			        					<div className="name">Priscilla Sorrentino</div>
			        				</div>

			        				<div className="card card--level4" style={ level4_card4 }>
			        					<div className="title">Operacional</div>
			        					<div className="name">Renato Souza</div>
			        				</div>

			        				<div className="card card--level4" style={ level5_card1 }>
			        					<div className="title">Finanças Corporativas<br />e Fundos Estruturados</div>
			        					<div className="name">Erika Lacreta</div>
			        				</div>

			        				<div className="card card--level4" style={ level5_card2 }>
			        					<div className="title">Informações Técnicas</div>
			        					<div className="name">Rodrigo Guerrero</div>
			        				</div>

			        				<div className="card card--level4" style={ level5_card3 }>
			        					<div className="title">Fundos de Investimento </div>
			        					<div className="name">Soraia Barros</div>
			        				</div>

			        				<div className="card card--level4" style={ level5_card4 }> 
			        					<div className="title">Sistemas</div>
			        					<div className="name">Adaline Viana</div>
			        				</div>


			        				<div className="card card--level4" style={ level6_card1 }>
			        					<div className="title">Distribuição de Produtos<br />de Investimento </div>
			        					<div className="name">Luiz Henrique</div>
			        				</div>

			        				<div className="card card--level4" style={ level6_card2 }>
			        					<div className="title">Precificação e Índices</div>
			        					<div className="name">Hilton Notini</div>
			        				</div>

			        				<div className="card card--level4" style={ level6_card3 }>
			        					<div className="title">Negociação, Distribuição<br />e Serviços Qualificados</div>
			        					<div className="name">Alessandro Rigon</div>
			        				</div>

			        				<div className="card" style={ level6_card4 }> 
			        					<div className="title">Suporte Técnico</div>
			        				</div>


			        				<div className="card card--level4" style={ level7_card1 }>
			        					<div className="title">Operações de Tesouraria</div>
			        					<div className="name">Anna Jimenez</div>
			        				</div>

			        				<div className="card card--level4" style={ level7_card2 }>
			        					<div className="title">Assessoria Técnica</div>
			        				</div>

			        				<div className="card" style={ level7_card4 }> 
			        					<div className="title">Segurança e Qualidade</div>
			        				</div>


			        				<div className="card card--level4" style={ level8_card2 }>
			        					<div className="title">Modelos e Controles</div>
			        					<div className="name">Leonardo Medina</div>
			        				</div>

			        				<div className="card card--level4" style={ level8_card1 }>
			        					<div className="title">Estudos Regulatórios</div>
			        				</div>

		        				</div>





		        				<div className="organograma__cards organograma__cards--mobile">

			        				<div className="card card--main card--level1" style={ level1_card1 }>
			        					<div className="title">Superintendência Geral</div>
			        					<div className="name">José Carlos Doherty</div>
			        				</div>

			        				<div className="card card--main card--level2" style={ level2_card2 }>
			        					<div className="title">Recursos Humanos</div>
			        					<div className="name">Eliana Marino</div>
			        				</div>

			        				<div className="card card--main card--level2" style={ level2_card3 }>
			        					<div className="title">Comunicação e Marketing</div>
			        					<div className="name">Marcelo Billi</div>
			        				</div>

			        				<div className="card card--main card--level2" style={ level2_card1 }>
			        					<div className="title">Assessoria Jurídica</div>
			        					<div className="name">Soraya Alves</div>
			        				</div>

			        				<div className="card card--main card--level2" style={ level2_card4 }>
			        					<div className="title">Controladoria<br />e Administração</div>
			        					<div className="name">Thiago Baptista</div>
			        				</div>

			        				<div className="card card--main card--level2" style={ level2_card5 }>
			        					<div className="title">Tecnologia da Informação </div>
			        					<div className="name">Lina Yajima</div>
			        				</div>



			        				<div className="card card--level3" style={ level3_card1 }>
			        					<div className="title">Representação<br />Institucional</div>
			        					<div className="name">Patrícia Herculano</div>
			        				</div>

			        				<div className="card card--level4" style={ level4_card1 }>
			        					<div className="title">Fundos de Investimento<br />e Serviços Qualificados </div>
			        					<div className="name">Tatiana Itikawa</div>
			        				</div>

			        				<div className="card card--level4" style={ level5_card1 }>
			        					<div className="title">Finanças Corporativas<br />e Fundos Estruturados</div>
			        					<div className="name">Erika Lacreta</div>
			        				</div>

			        				<div className="card card--level4" style={ level6_card1 }>
			        					<div className="title">Distribuição de Produtos<br />de Investimento </div>
			        					<div className="name">Luiz Henrique</div>
			        				</div>

			        				<div className="card card--level4" style={ level7_card1 }>
			        					<div className="title">Operações de Tesouraria</div>
			        					<div className="name">Anna Jimenez</div>
			        				</div>

			        				<div className="card card--main card--level4" style={ level8_card1 }>
			        					<div className="title">Estudos Regulatórios</div>
			        				</div>



			        				<div className="card card--level3" style={ level3_card2 }>
			        					<div className="title">Educação e<br />Informações Técnicas</div>
			        					<div className="name">Ana Leoni</div>
			        				</div>

			        				<div className="card card--level4" style={ level4_card2 }>
			        					<div className="title">Certificação e<br />Educação Continuada </div>
			        					<div className="name">Daniel Pfannemuller</div>
			        				</div>

			        				<div className="card card--level4" style={ level5_card2 }>
			        					<div className="title">Informações Técnicas</div>
			        					<div className="name">Rodrigo Guerrero</div>
			        				</div>

			        				<div className="card card--level4" style={ level6_card2 }>
			        					<div className="title">Precificação e Índices</div>
			        					<div className="name">Hilton Notini</div>
			        				</div>

			        				<div className="card card--level4" style={ level7_card2 }>
			        					<div className="title">Assessoria Técnica</div>
			        				</div>

			        				<div className="card card--main card--level4" style={ level8_card2 }>
			        					<div className="title">Modelos e Controles</div>
			        					<div className="name">Leonardo Medina</div>
			        				</div>



			        				<div className="card card--level3" style={ level3_card3 }>
			        					<div className="title">Supervisão de Mercados</div>
			        					<div className="name">Guilherme Benaderet</div>
			        				</div>

			        				<div className="card card--level4" style={ level4_card3 }>
			        					<div className="title">Ofertas Públicas<br />e Certificação</div>
			        					<div className="name">Priscilla Sorrentino</div>
			        				</div>

			        				<div className="card card--level4" style={ level5_card3 }>
			        					<div className="title">Fundos de Investimento </div>
			        					<div className="name">Soraia Barros</div>
			        				</div>

			        				<div className="card card--main card--level4" style={ level6_card3 }>
			        					<div className="title">Negociação, Distribuição<br />e Serviços Qualificados</div>
			        					<div className="name">Alessandro Rigon</div>
			        				</div>



			        				<div className="card card--level3" style={ level3_card4 }> 
			        					<div className="title">Selic</div>
			        					<div className="name">Francisco Vidinha</div>
			        				</div>

			        				<div className="card card--level4" style={ level4_card4 }>
			        					<div className="title">Operacional</div>
			        					<div className="name">Renato Souza</div>
			        				</div>

			        				<div className="card" style={ level6_card4 }> 
			        					<div className="title">Suporte Técnico</div>
			        				</div>

			        				<div className="card" style={ level7_card4 }> 
			        					<div className="title">Segurança e Qualidade</div>
			        				</div>

		        				</div>




		        				{
		        					!isMobile && 
		        					<img src={ this.images.vector_organograma } className="vectors" />
		        				}

		        				{
		        					isMobile && 
		        					<img src={ this.images.vector_organograma_mobile } className="vectors" />
		        				}

		        			</div>
		        		</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { Pessoas };
